import React from 'react'

export default function BuyAmenities({PropertyAmenities}) {
  return (
    <>
      {/* if amentities is there then only show the amenities */}
      {PropertyAmenities?.length > 0 ? (
                <div className="Property-amenities property-details-block">
                  <div className="row">
                    <div className="col-12">
                      <div className="amenities-details">
                        <h3>Amenities</h3>
                        <ul className="amenities-grid">
                          {PropertyAmenities.map((amenity, index) => (
                            <li key={index}>
                              <img
                                src={amenity.amenityIcon}
                                alt={amenity.amenityName}
                                width={24}
                                height={24}
                              />
                              {amenity.amenityName}
                            </li>
                          ))}

                        
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              </>
  )
}
